import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { bentoTileStyles } from '../BentoGrid/BentoGrid.styles';

export type BentoTileSize = keyof typeof bentoTileStyles.size;
export type BentoTileTone = keyof typeof bentoTileStyles.tone;

export type BentoTileProps = {
  title: string;
  description?: string;
  imageSrc?: string;
  href: string;
  size?: BentoTileSize;
  tone?: BentoTileTone;
  ctaLabel?: string;
  className?: string;
};

export function BentoTile({
  title,
  description,
  imageSrc,
  href,
  size = 'medium',
  tone = 'nav',
  ctaLabel,
  className,
}: BentoTileProps): JSX.Element {
  return (
    <Link
      to={href}
      className={cn(
        bentoTileStyles.root,
        bentoTileStyles.size[size],
        bentoTileStyles.tone[tone],
        className,
      )}
    >
      {imageSrc ? <img src={imageSrc} alt="" className={bentoTileStyles.image} /> : null}
      <div className={bentoTileStyles.content}>
        <h3 className={bentoTileStyles.title}>{title}</h3>
        {description ? <p className={bentoTileStyles.description}>{description}</p> : null}
        {ctaLabel ? <span className={bentoTileStyles.cta}>{ctaLabel}</span> : null}
      </div>
    </Link>
  );
}
